export default "__VITE_ASSET__kMxB1p4i__"